import React, { useEffect, useState } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './BrandLogoSlider.styles.css';

const BrandLogoSlider = ({brand}) => {
  const options = {
    margin: 5,
    responsiveClass: true,
    nav: false,
    dots: false,
    loop: true,
    navText: ["<span></span>", "<span></span>"],
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 4,
      },
      600: {
        items: 6,
      },
      700: {
        items: 7,
      },
      1000: {
        items: 10,
      }
    },
  };

  var RenderData = () =>{
    return (
      <OwlCarousel id="brand-logo-slider" className="product-flexslider hidden-buttons owl-theme"  {...options} >
        {sliderList?.map((logo, index) => {
          return (
            <div className="item" key={index}>
              <img src={logo.image} alt={logo.alt} />
            </div>
          )
        })}
      </OwlCarousel>
    );
  };

  const [sliderList, setSliderList] = useState([]);

  const getSliders = async () => {
    await Axios.get('/cms/home-partner')
      .then(function (response) {
        if (response.data) {
          const responseData = response.data;
          if (responseData.length > 0) {
            setSliderList(responseData);
          }
          else {
            // setSliderList([]);
          }
        }
      })
      .catch(function (error) {
        // setSliderList([]);
      });
  };

  useEffect(() => {
    if(brand){
      setSliderList(brand);
    }else{
      getSliders();
    }
  }, [brand])

  return (
    <div className="brand-logo">
      <div className="container">
        <div className="slider-items-products">
          <div className="slider-items slider-width-col6">
            <RenderData/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandLogoSlider;
